module.exports = __webpack_public_path__ + "static/img/8619_phase_function_Paper_PointsHejduk_Prediction.fb71f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8619_phase_function_Paper_PointsHejduk_Prediction.png
// module id = O68g
// module chunks = 0